import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CasesContext = createContext();
const API = process.env.REACT_APP_API_URL;

export const CasesProvider = ({ children }) => {
  const [cases, setCases] = useState([]);

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const token = sessionStorage.getItem("token");
        let response;

        if (token) {
          // admin ke liye secured route
          response = await axios.get(`${API}/api/cases`, {
            headers: { Authorization: `Bearer ${token}` },
          });
        } else {
          // public users ke liye open route
          response = await axios.get(`${API}/api/cases/public`);
        }

        setCases(response.data);
      } catch (err) {
        console.error("Error fetching cases:", err);
      }
    };

    fetchCases();
  }, []);

  return (
    <CasesContext.Provider value={{ cases, setCases }}>
      {children}
    </CasesContext.Provider>
  );
};

export const useCases = () => useContext(CasesContext);
